import { Theme } from '@mui/material/styles';
import { SxProps } from '@mui/system';
import { brandColors, hoverOnly } from '../../theme/mixins';

export const wrapperStyles: SxProps<Theme> = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 1,
};

/**
 * The thumbnail is the control: tapping the figure is the obvious way to draw on it, and a
 * button beside it would be a second way to do one thing. Since nothing else says so, the
 * border answers on hover -- guarded, or a touch browser leaves it lit on the last tap.
 */
export const thumbnailButtonStyles: SxProps<Theme> = {
    position: 'relative',
    display: 'block',
    width: '100%',
    maxWidth: 240,
    aspectRatio: '800 / 1013',
    // Drawn on white for the reason the dialog's stage is -- see bodyDiagramDialog.styles.
    backgroundColor: 'common.white',
    border: '1px solid',
    borderColor: 'divider',
    borderRadius: 1,
    overflow: 'hidden',
    transition: 'border-color .2s ease',
    ...hoverOnly({ borderColor: brandColors.primary }),
};

export const thumbnailLayerStyles: SxProps<Theme> = {
    position: 'absolute',
    inset: 0,
    width: '100%',
    height: '100%',
    display: 'block',
    pointerEvents: 'none',
};

export const hintStyles: SxProps<Theme> = {
    color: 'text.secondary',
    fontSize: '0.8rem',
    textAlign: 'center',
};
